import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Tooltip,
} from "@mui/material";
import { AddCircle } from "@mui/icons-material";
import LearningModal from "./LearningModal";

const Learning = () => {
  const [showLearningModal, setShowLearningModal] = useState(false);

  const handleLearningShow = () => setShowLearningModal(true);
  const handleLearningClose = () => setShowLearningModal(false);

  const columns = [
    "Recorded Date",
    "Improvement Area",
    "Issue",
    "Action Taken",
    "Action Type",
    "Action Date",
    "Status",
  ];

  return (
    <Box>
      <Card>
        <CardContent>
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              py: 1.5,
              mb: 2,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                color: "primary.main",
                fontWeight: 700,
              }}
            >
              Learning &amp; Improvement
            </Typography>

            <Tooltip title="Add Learning" arrow>
              <IconButton
                color="primary"
                onClick={handleLearningShow}
                size="small"
              >
                <AddCircle fontSize="medium" />
              </IconButton>
            </Tooltip>
          </Box>

          {/* Modal */}
          <LearningModal
            show={showLearningModal}
            onHide={handleLearningClose}
            size="lg"
            centered
          />

          {/* Table */}
          <TableContainer component={Paper} variant="outlined">
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#f8f9fa" }}>
                  {columns.map((col) => (
                    <TableCell key={col} sx={{ fontWeight: 700 }}>
                      {col}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {/* No rows — empty state below */}
              </TableBody>
            </Table>
          </TableContainer>

          <Typography sx={{ mt: 2, color: "text.secondary" }}>
            No record found.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Learning;